import type { FeaturePurchaseOfferDefinition } from "@slot/game-shell";
import { SECRET_BONUS_OFFER } from "../features/secret-bonus/secretBonusOffer";

/**
 * The purchase offers (an id is the server contract: it rides `SpinRequest.requestedFeatureIdentifier` verbatim):
 * `free_spins_buy` buys straight into the free-spins round from the purchase panel; `secret_bonus`, unlisted, is offered
 * only by the Secret Bonus symbol (decision 51). A price is the operator's (`initialSettings.featurePriceMultipliersById`);
 * an offer without a positive one is dropped by the shell.
 */
export function createFeaturePurchaseOffers(): FeaturePurchaseOfferDefinition[] {
  return [
    {
      id: "free_spins_buy",
      actionType: "bonus_buy",
      titleKey: "feature_purchase.free_spins_buy.title",
      descriptionKey: "feature_purchase.free_spins_buy.description",
      fallbackTitle: "Bonus Buy",
      fallbackDescription: "Buy your way straight to the free-spins round.",
      iconPath: "feature-purchase/icons/free_spins/spriteFrame",
    },
    SECRET_BONUS_OFFER,
  ];
}
